import React from "react";

export default function SpecPanel() {
  return <div>SpecPanel</div>;
}
